import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import theme from '../../../styles/theme';
import GlobalStyles from '../../../styles/GlobalStyles';
import Helmet from 'react-helmet';
import '../../../static/fonts/fonts.css';

const Layout = ({ children }) => (
  <ThemeProvider theme={theme}>
    <React.Fragment>
      <GlobalStyles />
      <Helmet>
        <script type="text/javascript">{`
         	window.fwSettings={
 	'widget_id':67000001332
 	};
    `}</script>
        <script
          type="text/javascript"
          src="https://widget.freshworks.com/widgets/67000001332.js"
          async
          defer
        ></script>
        <script>
        {` 
        function createFcn(nm){(window.freshsales)[nm]=function(){(window.freshsales).push([nm].concat(Array.prototype.slice.call(arguments,0)))}; } (function(url,appToken,formCapture){window.freshsales=window.freshsales||[];if(window.freshsales.length==0){list='init identify trackPageView trackEvent set'.split(' ');for(var i=0;i<list.length;i++){var nm=list[i];createFcn(nm);}var t=document.createElement('script');t.async=1;t.src='https://assets.freshsales.io/assets/analytics.js';var ft=document.getElementsByTagName('script')[0];ft.parentNode.insertBefore(t,ft);freshsales.init('https://dealmap.freshsales.io','a11809247e740c58d7c72cede7f87a9b3288f0c1fa0cfaa11cc99a85f349c9a2',true);}})();
        `}
      </script>
      </Helmet>
      {children}
    </React.Fragment>
  </ThemeProvider>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
